/* eslint-disable react/jsx-pascal-case */
import {
    Col, Form, Input, Row, Select, DatePicker, Switch
} from "./../../ui/ot";
import { useKeyword } from "../../keyword/controller/KeywordController";
import { useMesaageTemplate } from "../../mesaage_template/controller/MesaageTemplateController";
import dayjs from 'dayjs';
import React, { useEffect } from "react";
import { useCan } from "../../can/controller/CanController";
const AutoReplyForm = (
    {
        propsForm = null,
        field,
        axiosMode = "post",
        formReloadCount = 0,
        onFormFinish = () => { },
    }
) => {
    const [form] = Form.useForm();

    const setFormValuesOtherThings = (formValues) => {
        //做一些你可能會用到其他component的資料整理
        let newFormValues = {
            ...formValues,
            total: (formValues?.comments * formValues?.number) || 0
        }
        if (propsForm) {
            propsForm.setFieldsValue(newFormValues)
        }
        else {
            form.setFieldsValue(newFormValues)
        }

    }

    const setDataInitialization = () => {
        //拿個下拉選單等等的資訊
    }
    const onFinish = (values) => {
        onFormFinish(values)
    }
    const onValuesChange = () => {
        let formValues = null
        if (propsForm) {
            formValues = propsForm.getFieldsValue()
        }
        else {
            formValues = form.getFieldsValue()
        }
        // setFormValuesOtherThings(formValues)
    }
    const {

        getKeywordOption,
        keywordOption
    } = useKeyword({
        onFinish: () => { },
        onBefore: () => { },
    })
    const {
        getMesaageTemplateOption,
        mesaageTemplateOption
    } = useMesaageTemplate({
        onFinish: () => { },
        onBefore: () => { },
    })
    const {
        getCanOption,
        canOption,
    } = useCan({
        onFinish: () => { },
        onBefore: () => { },
    })
    useEffect(() => {
        setDataInitialization()
        getCanOption()
        getKeywordOption()
    }, [])
    useEffect(() => {
        getKeywordOption()
    }, [])
    useEffect(() => {
        getKeywordOption()

        let formValues = null
        if (propsForm) {
            formValues = propsForm.getFieldsValue()
        }
        else {
            formValues = form.getFieldsValue()
        }
    }, [formReloadCount])

    return (
        <Row>
            <Col span={24}>
                <Form
                    labelCol={{ span: 6 }}
                    wrapperCol={{ span: 18 }}
                    layout="horizontal"
                    form={propsForm ? propsForm : form}
                    onValuesChange={onValuesChange}
                    onFinish={onFinish}
                    autoComplete="off"
                >
                    <Row gutter={[8, 8]}>
                        <Col span={24}>
                            <Form.Item
                                hidden={true}
                                label={"autoreply_id"}
                                name={[field?.name ?? '', "autoreply_id"]}
                            >
                            </Form.Item>
                        </Col>

                        <Col span={24}>
                            <Form.Item
                                // hidden={true}
                                label={"標題"}
                                name={[field?.name ?? '', "autoreply_name"]}
                                rules={[
                                    {
                                        required: true,
                                        message: "請輸入"
                                    }
                                ]}
                            >
                                <Input>
                                </Input>
                            </Form.Item>
                        </Col>


                        <Col span={24}>
                            <Form.Item
                                label={"關鍵字"}
                                name={[field?.name ?? '', "keyword_id"]}
                                rules={[
                                    {
                                        required: true,
                                        message: "請輸入"
                                    }
                                ]}
                            >
                                <Select
                                    mode="tags"
                                    options={keywordOption}
                                    onlyValue={false}
                                    onlyValueAll={true}
                                >

                                </Select>

                            </Form.Item>
                        </Col>
                        <Col span={24}>
                            <Form.Item
                                label={"訊息樣板"}
                                name={[field?.name ?? '', "can_id"]}
                                rules={[
                                    {
                                        required: true,
                                        message: "請輸入"
                                    }
                                ]}
                            >
                                <Select
                                    options={canOption}
                                >
                                </Select>
                            </Form.Item>
                        </Col>
                        <Col span={24}>
                            <Form.Item
                                label={"是否啟用"}
                                name={[field?.name ?? '', "activation"]}
                                valuePropName="checked"
                                initialValue={false}
                                rules={[
                                    {
                                        required: true,
                                        message: "請輸入"
                                    }
                                ]}
                            >
                                <Switch mode="number"></Switch>

                            </Form.Item>
                        </Col>
                        <Col span={24}>
                            <Form.Item
                                label={"啟用日期"}
                                name={[field?.name ?? '', "active_date"]}
                                hidden={true}

                            >
                            </Form.Item>
                        </Col>
                        <Col span={24}>
                            <Form.Item
                                label={"啟用時間"}
                                name={[field?.name ?? '', "active_time"]}
                                hidden={true}
                            >
                            </Form.Item>
                        </Col>
                    </Row>
                </Form>
            </Col>
        </Row>
    )
}



export default AutoReplyForm;
